<!-- <div mat-dialog-actions> -->
<!-- <mat-icon class="close-btn" (click)="onNoClick()">close</mat-icon> -->
<div class="row m-auto mb-5  justify-content-between zoomImage-header">
    <div>
        <div *ngIf="imageZoomedStatus">
            <img src="assets/img/doubts/icons8-rotate-24.png" class="mdl-cls-icn" *ngIf="this.previewData?.value==1" width="12px" (click)="rotateClockwise() " />
            <i class="fa fa-rotate-right c-pointer" style="opacity:0" *ngIf="this.previewData?.value==2 "
                (click)="rotateClockwise() "></i>
        </div>
    </div>
    
    <div>
        <i class="fa c-pointer zoom-btn" [ngClass]="imageZoomedStatus?'fa-search-minus':'fa-search-plus'" (click)="imageZoom() "></i>
        <!-- <i class="fa fa-close c-pointer " (click)="onNoClick() "></i> -->
        <img src="assets/img/close-black-icon.svg" class="mdl-cls-icn" (click)="onNoClick() "/>
        <!-- <button class="TCHPRF-prfledit-modal-cls-btn" type="button" mat-dialog-close (click)="onNoClick() ">
        </button> -->
    </div>
    
    
</div>
<!-- </div> -->
<!-- <div mat-dialog-content>
  <img [src]="this.data " [ngClass]="{ 'rotate-0':rotate==0 , 'rotate-90' : rotate==1 , 'rotate-180':rotate==2 , 'rotate-270' :rotate==3 } " class="img-fluid " />
</div> -->



<div mat-dialog-content *ngIf="this.previewData?.value==1 ">
    <!-- <div class="zoom-btn">
        <i class="fa fa-search-plus" aria-hidden="true"></i>
    </div> -->
    <div class="zoom-image-wrap-popup " [ngClass]="imageZoomedStatus?'image-zoomed':''">
        <img [src]="this.previewData?.data " [ngClass]="{ 'rotate-0':rotate==0 , 'rotate-90' : rotate==1 , 'rotate-180':rotate==2 , 'rotate-270' :rotate==3 } " class="img-fluid c-pointer" (click)="imageZoom()" />
    </div>
</div>
<div mat-dialog-content *ngIf="this.previewData?.value==2 ">
    <div class="zoom-image-wrap-popup ">
        <div [innerHtml]="this.previewData?.data " [ngClass]="{ 'rotate-0':rotate==0 , 'rotate-90' : rotate==1 , 'rotate-180':rotate==2 , 'rotate-270' :rotate==3 } " class="img-fluid "></div>
    </div>
</div>